import { Button, FileField, FileInput, NumberInput, required, minValue, useNotify, useRefresh } from "react-admin";
import AddIcon from "@mui/icons-material/Add";
import { Box, Grid, Tooltip } from "@mui/material";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import { specialistRequests } from "api/specialistApi";
import UploadFileIcon from "@mui/icons-material/UploadFile";

const AddAdditionalTrainingRecommendationDialog = ({ id, fullyCoversStudyDuration }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const blockedReason = !fullyCoversStudyDuration
    ? "Допълнително обучение може да се добави само след като периодите покрият цялата продължителност на обучението."
    : null;

  const handleSubmit = async data => {
    const payload = {
      durationInDays: data.durationInDays,
      protocolFile: data.protocolFile,
    };
    await dataProvider.customRequest(
      specialistRequests.addAdvancedSpecializationSpecialistAdditionalTrainings(id),
      payload,
      "POST",
      undefined, // params
      true, // isMultipart — payload съдържа protocolFile
    );
    notify("Успешно добавихте допълнително обучение", { type: "success" });
    refresh();
  };

  if (blockedReason) {
    return (
      <Tooltip title={blockedReason}>
        <span>
          <Button
            label="Добави допълнително обучение"
            startIcon={<AddIcon />}
            variant="contained"
            sx={{ m: 2 }}
            disabled
          />
        </span>
      </Tooltip>
    );
  }

  return (
    <FormModal
      titleContent={"Добавяне на допълнително обучение"}
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          label="Добави допълнително обучение"
          startIcon={<AddIcon />}
          variant="contained"
          sx={{ m: 2 }}
        />
      }
    >
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={6}
        >
          <NumberInput
            source="durationInDays"
            label="Продължителност (дни)"
            validate={[required(), minValue(1)]}
            onWheel={e => e.target.blur()}
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <FileInput
            placeholder={
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
                <UploadFileIcon />
                {"Добавете файл в pdf, png или jpg формат"}
              </Box>
            }
            source="protocolFile"
            label="Изпитен протокол"
            accept={{
              "application/pdf": [".pdf"],
              "image/png": [".png"],
              "image/jpeg": [".jpg", ".jpeg"],
            }}
            validate={required()}
          >
            <FileField
              source="src"
              title="title"
            />
          </FileInput>
        </Grid>
      </Grid>
    </FormModal>
  );
};

export default AddAdditionalTrainingRecommendationDialog;
